import {useState} from "react";
import {TenantDto} from "../../model/TenantDto";
import {customAxios} from "../customAxios";

export function useUpdateTenant() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<TenantDto>();
    const [error, setError] = useState<Error>();

    async function execute(dto: TenantDto, tenantId: number) {
        try {
            setLoading(true);
            setError(undefined);
            const data = await updateTenant(dto, tenantId);
            setData(data);
            return data;
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }


    return {
        loading, data, error, execute
    };
}

export async function updateTenant(dto: TenantDto, tenantId: number): Promise<TenantDto> {
    const response = await customAxios.put<TenantDto>(`/v1/tenant/${tenantId}`, dto);
    return response.data;
}
